import React, { useState } from 'react';

type TextBoxProps = {
  id: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  placeholder?: string;
  labelClass?: string;
  className?: string;
  isBaseClass?: boolean;
  isFlat?: boolean;
  disabled?: boolean;
  autoComplete?: string;
};

const TextBox: React.FC<TextBoxProps> = ({
  id,
  value,
  onChange,
  label,
  placeholder = "",
  labelClass = "",
  className = "",
  isBaseClass = true,
  isFlat = false,
  disabled = false,
  autoComplete="",
}) => {
  const [inputValue, setInputValue] = useState(value || "");
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    onChange?.(e);
  };
  const divClass = isFlat ? 'textbox-flat' : '';

  return (
    <div className={divClass}>
      {label && (
        <label htmlFor={id} className={`textbox-label ${labelClass}`}>
          {label}
        </label>
      )}
      <input
        type="text"
        id={id}
        {...(onChange
          ? { value: inputValue, onChange: handleChange }
          : { defaultValue: value })}
        className={isBaseClass ? `textbox-input ${className}` : className}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={autoComplete}
      />
    </div>
  );
};

export default TextBox;
